import {StyleSheet} from 'react-native';

import {black, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 100,
    right: 20,
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    zIndex: 1000,
  },
  iconContainer: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: 24,
    color: white,
  },
});

export const createDynamicStyles = (primaryColor: string) =>
  StyleSheet.create({
    containerBackground: {
      backgroundColor: primaryColor,
    },
  });
